//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return{
      hide:false,
      dn_top:'',
      dns:{
        dns1:'',
        dns2:'',
      },
      domain:{
        name:'',
        org:''
      },
      organizeman_cn:'',
      applyDate:'',
      expireDate:'',
      shiming:{
        auditStatus:''
      },
    }
  },
  mounted() {
    this.DomainQuery()
  },
  methods:{
    DomainQuery() {
      let data = 'cmd=domain_query'+
        '&id='+ this.$route.params.id
      this.$http.post('https://api.abeiyun.com/www/domain.php', data).then(({data}) => {
        if(data.response == 200) {
          this.dn_top = data.dn_top
          this.domain.name = data.info.msg.data.domain
          this.domain.org = data.info.msg.org
          this.organizeman_cn = data.info.msg.data.r_organize_name_cn
          this.applyDate = data.info.msg.data.applyDate
          this.expireDate = data.info.msg.data.expireDate
          this.dns.dns1 = data.info.msg.data.dns[0]
          this.dns.dns2 = data.info.msg.data.dns[1]
          this.shiming.auditStatus = data.shiming.auditStatus
        }
      })
    },
    Record() {
      this.$router.push('/user/domainrecord/'+this.domain.name)
    },
    Analy() {
      this.$router.push('/user/domainanaly/'+this.domain.name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/domainmanage.vue